import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=4c127025&"
var script = {}
import style0 from "./ContactView.vue?vue&type=style&index=0&id=4c127025&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports